import {Button, Row, Space, Table, Typography} from "antd";

import {HeaderPrintForm, Sign} from "components/common/PrintForm";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppSelector} from "redux/hooks";
import {columns as columnsInit} from "./config";
import {formatDateToString, formatToCurrencyTypeToFixed} from "helper/common";
import {CURRENCY_LOCALE, FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import moment from "moment";
import "./ReceiptModal.scss";
import Descriptions from "components/common/DescriptionsCustom/DescriptionsCustom";
import DescriptionsItem from "components/common/DescriptionsCustom/DescriptionsItemCustom";

const ReceiptModal = props => {
  const {closeModal} = props;
  const printRef = useRef<any>();
  const typePhieu = useAppSelector(state => state.pharmacyStore.typePhieu);
  const detailRecord = useAppSelector(
    state => state.pharmacyStore.detailRecord
  );
  const [textTypePhieu, setTextTypePhieu] = useState<string>("");

  const [dataTable, setDataTable] = useState<any[]>([]);
  const fieldsInit: any[] = [
    {label: "Số phiếu", value: detailRecord?.receiptDto?.id},
    {label: "Kho nhập", value: detailRecord?.receiptDto?.khoNhap},
    {label: "Kho xuất", value: detailRecord?.receiptDto?.khoXuat},
    {
      label: "Nhà cung cấp",
      value: detailRecord?.receiptDto?.nhaCungCap,
      span: 24,
    },

    {
      label: "Địa chỉ NCC",
      value: detailRecord?.receiptDto?.diaChiNCC,
      span: 24,
    },
    {
      label: "Ngày xuất",
      value: detailRecord?.receiptDto?.ngayHoanThanh,
    },
    {
      label: "Ngày hóa đơn",
      value: formatDateToString(
        moment(detailRecord?.receiptDto?.ngayHoaDon),
        FORMAT_TIME.dateTime
      ),
    },
    {label: "Số hóa đơn", value: detailRecord?.receiptDto?.soHoaDon},
    {label: "Ghi chú", value: detailRecord?.receiptDto?.ghiChu},
  ];

  const [fields, setFields] = useState<any>(fieldsInit);
  const [columns, setColumns] = useState<any>(columnsInit);
  // const fields2 = [
  //   {
  //     label: "Ngày hóa đơn",
  //     value: formatDateToString(
  //       moment(detailRecord?.receiptDto?.ngayHoaDon),
  //       FORMAT_TIME.dateTime
  //     ),
  //   },
  //   {label: "Số hóa đơn", value: detailRecord?.receiptDto?.soHoaDon},
  // ];
  useEffect(() => {
    if (detailRecord) {
      setDataTable(detailRecord?.listReceiptDetailDto);
      const setValueDescription = () => {
        fields.find(e => e?.label == "Số phiếu").value =
          detailRecord?.receiptDto?.id;
        fields.find(e => e?.label == "Kho nhập").value =
          detailRecord?.receiptDto?.khoNhap;
        fields.find(e => e?.label == "Kho xuất").value =
          detailRecord?.receiptDto?.khoXuat;
        fields.find(e => e?.label == "Nhà cung cấp").value =
          detailRecord?.receiptDto?.nhaCungCap;
        fields.find(e => e?.label == "Địa chỉ NCC").value =
          detailRecord?.receiptDto?.diaChiNCC;
        fields.find(e => e?.label == "Ngày xuất").value = formatDateToString(
          moment(detailRecord?.receiptDto?.ngayHoanThanh),
          FORMAT_TIME.dateTime
        );
        fields.find(e => e?.label == "Ngày hóa đơn").value = formatDateToString(
          moment(detailRecord?.receiptDto?.ngayHoaDon),
          FORMAT_TIME.dateTime
        );
        fields.find(e => e?.label == "Số hóa đơn").value =
          detailRecord?.receiptDto?.soHoaDon;
        fields.find(e => e?.label == "Ghi chú").value =
          detailRecord?.receiptDto?.ghiChu;
        fields.find(e => e?.label == "Ghi chú").hidden =
          !detailRecord?.receiptDto?.ghiChu;
        const hidden = !(
          (detailRecord?.receiptDto?.khoNhap == "Các Kho nhà cung cấp" &&
            detailRecord?.receiptDto.loaiPhieu == LOAI_PHIEU_KHO.XUAT) ||
          detailRecord?.receiptDto.loaiPhieu == LOAI_PHIEU_KHO.NHAP
        );
        fields.find(e => e?.label == "Nhà cung cấp").hidden = hidden;

        setFields(fields);
      };
      setValueDescription();
    }
  }, [detailRecord]);
  useEffect(() => {
    setNamePhieu();
    setFieldsShow();
    setColumnsShow();
  }, [typePhieu]);
  const setNamePhieu = () => {
    if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
      setTextTypePhieu("NHẬP");
    }
    if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
      setTextTypePhieu("XUẤT");
    }
    if (typePhieu == LOAI_PHIEU_KHO.DU_TRU) {
      setTextTypePhieu("LĨNH THUỐC");
    }
  };
  const setFieldsShow = () => {
    fields.find(e => e.label == "Số phiếu").hidden =
      typePhieu != LOAI_PHIEU_KHO.NHAP;
    fields.find(e => e.label == "Kho xuất").hidden =
      typePhieu == LOAI_PHIEU_KHO.NHAP;
    // fields.find(e => e.label == "Nhà cung cấp").hidden =
    //   typePhieu != LOAI_PHIEU_KHO.NHAP;
    fields.find(e => e.label == "Địa chỉ NCC").hidden =
      typePhieu != LOAI_PHIEU_KHO.NHAP;
    fields.find(e => e.label == "Số hóa đơn").hidden =
      typePhieu != LOAI_PHIEU_KHO.NHAP;
    fields.find(e => e.label == "Ngày xuất").hidden =
      typePhieu != LOAI_PHIEU_KHO.XUAT;

    setFields([...fields]);
  };
  const setColumnsShow = () => {
    columnsInit.find(e => e.title == "Đơn giá bán").show =
      typePhieu != LOAI_PHIEU_KHO.DU_TRU;
    columnsInit.find(e => e.title == "SL xuất").show =
      typePhieu == LOAI_PHIEU_KHO.XUAT;
    columnsInit.find(e => e.title == "SL nhập").show =
      typePhieu != LOAI_PHIEU_KHO.XUAT;
    setColumns(columnsInit.filter(e => e?.show));
  };
  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="print-form store-receipt">
      <div ref={printRef} className="">
        <table>
          <thead>
            <tr style={{height: "20mm"}}></tr>
          </thead>
          <tbody>
            <HeaderPrintForm></HeaderPrintForm>
            <div>
              <div style={{marginBottom: 8}}>
                <Row justify={"center"}>
                  <Typography.Title
                    style={{
                      fontWeight: "700",
                      fontSize: 30,
                    }}
                  >
                    PHIẾU {textTypePhieu}
                  </Typography.Title>
                </Row>
                <div>
                  <Descriptions
                    size="small"
                    // column={{xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6}}
                  >
                    {/* <Row wrap={true} style={{width: "100%"}}> */}
                    {fields &&
                      fields
                        .filter(e => e?.hidden != true)
                        .map(e => (
                          // <Col span={12}>
                          <DescriptionsItem label={e.label} span={e?.span}>
                            {e?.value ?? "--"}
                          </DescriptionsItem>
                          // </Col>
                        ))}
                    {/* </Row> */}
                  </Descriptions>
                </div>
              </div>
              {dataTable.length > 0 && (
                <div className="container2">
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 20,
                        marginBottom: 8,
                      }}
                    >
                      Danh sách thuốc
                    </Typography.Text>
                  </Row>

                  <Table
                    className="table-print"
                    columns={columns}
                    dataSource={dataTable}
                    pagination={false}
                    bordered
                  ></Table>
                </div>
              )}
              <Row justify={"end"} style={{marginTop: 12}}>
                <div className="container-value" style={{textAlign: "end"}}>
                  <span style={{fontWeight: 600}}>Tổng giá trị: </span>
                  {detailRecord && (
                    <span>
                      {formatToCurrencyTypeToFixed(
                        detailRecord?.receiptDto?.tongGiaTri,
                        2,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  )}
                </div>
              </Row>
              <Row
                style={{
                  marginTop: 36,
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Sign
                  isRow={typePhieu != LOAI_PHIEU_KHO.NHAP}
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  justify="start"
                  label={
                    typePhieu == LOAI_PHIEU_KHO.DU_TRU
                      ? "Người giao"
                      : "Người tạo"
                  }
                  nguoiThucHien={
                    typePhieu == LOAI_PHIEU_KHO.DU_TRU
                      ? detailRecord?.receiptDto?.nguoiGiao
                      : detailRecord?.receiptDto?.nguoiLap
                  }
                ></Sign>{" "}
                {typePhieu == LOAI_PHIEU_KHO.NHAP && (
                  <Sign
                    isRow={false}
                    style={{marginTop: 0, width: "fit-content"}}
                    span={24}
                    justify="start"
                    label={"Người giao"}
                    time={detailRecord?.receiptDto?.createDate}
                    nguoiThucHien={detailRecord?.receiptDto?.nguoiGiao}
                  ></Sign>
                )}
                <Sign
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  justify="start"
                  label="Người nhận"
                  nguoiThucHien={
                    typePhieu == LOAI_PHIEU_KHO.DU_TRU
                      ? detailRecord?.receiptDto?.nguoiNhan
                      : detailRecord?.receiptDto?.nguoiNhan
                  }
                  time={detailRecord?.receiptDto?.ngayHoanThanh}
                ></Sign>
                {/* </Space> */}
              </Row>
            </div>
          </tbody>
          <tfoot>
            <tr style={{height: "2cm"}}></tr>
          </tfoot>
        </table>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button
            danger
            onClick={() => {
              closeModal();
            }}
          >
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-form store-receipt"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default ReceiptModal;
